import {ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {
    FormsModule,
    ReactiveFormsModule,
    UntypedFormBuilder,
    UntypedFormGroup,
} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatOptionModule} from '@angular/material/core';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatStepperModule} from '@angular/material/stepper';
import {MatDivider} from "@angular/material/divider";
import {NgForOf, NgIf} from "@angular/common";
import {TranslocoPipe} from "@ngneat/transloco";
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from "@angular/material/datepicker";
import {SignatureComponent} from "../../../signature/signature.component";
import {BasicInfoFieldNames} from "../../../basic-info/basic.patient.info.types";
import {MatSlideToggle} from "@angular/material/slide-toggle";
import {DocummentsService} from "../../../documents.service";
import {DocUserField, GeneralFieldNames} from "../../../document-types";
import {ActivatedRoute, Router} from "@angular/router";
import {BasicWizzard} from "../../../base-behaviour/wizzard";
import {getRawVal, getValueOfFieldWithName} from "../../../base-behaviour/base.behaviour.doc.types";
import {GdprFieldNames} from "../../gdpr.consimtamant.types";
import {GDPRAnsw, GdprQ, gdprQuestions} from "../gdpr.consimtamant.sib.v1.types";
import {FuseAlertComponent} from "../../../../../../@fuse/components/alert";

@Component({
    selector     : 'gdpr-sib-v1-wizzard',
    templateUrl  : 'gdpr.wizzard.sib.v1.html',
    encapsulation: ViewEncapsulation.None,
    standalone   : true,
    styles: `
        input[type=checkbox] {
            transform: scale(1.5);
        }
    `,
    imports: [MatIconModule, FormsModule, ReactiveFormsModule, MatStepperModule, MatFormFieldModule, MatInputModule, MatSelectModule, MatOptionModule, MatButtonModule, MatCheckboxModule, MatRadioModule, MatDivider, NgIf, TranslocoPipe, MatDatepicker, MatDatepickerInput, MatDatepickerToggle, SignatureComponent, MatSlideToggle, NgForOf, FuseAlertComponent],
})
export class GdprWizzardSibV1 extends BasicWizzard implements OnInit, OnDestroy
{
    buletinInfForm: UntypedFormGroup;
    @ViewChild(SignatureComponent) signature!: SignatureComponent;
    patched=false;
    clinicName= "-";
    clinicAddress = "-";
    clinicEmail = "-";


    fieldsData: Record<GdprFieldNames, boolean|string> = {
        GDPR_AGREE_SB_V1__info1_1 : false,

        GDPR_AGREE_SB_V1__info2_1 : false,
        GDPR_AGREE_SB_V1__info2_2 : false,
        GDPR_AGREE_SB_V1__info2_3 : false,
        GDPR_AGREE_SB_V1__info2_4 : false,
        GDPR_AGREE_SB_V1__info2_5 : false,
        GDPR_AGREE_SB_V1__info2_6 : false,

        GDPR_AGREE_SB_V1__info3_1 : false,
        GDPR_AGREE_SB_V1__info3_2 : false,
        GDPR_AGREE_SB_V1__info3_3 : false,
        GDPR_AGREE_SB_V1__info3_4 : false,
        GDPR_AGREE_SB_V1__info3_5 : false,
        GDPR_AGREE_SB_V1__info3_6 : false,
        GDPR_AGREE_SB_V1__info3_7 : false,
        GDPR_AGREE_SB_V1__info3_8 : false,
        GDPR_AGREE_SB_V1__info3_9 : false,
    }


    /**
     * Constructor
     */
    constructor(
        private readonly _formBuilder: UntypedFormBuilder,
        _docsService: DocummentsService,
        route: ActivatedRoute,
        router: Router,
        cdrf: ChangeDetectorRef,
    )
    {
        super(_docsService, route, router, cdrf);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {

        // Vertical stepper form
        this.buletinInfForm = this._formBuilder.group({
            step1: this._formBuilder.group({
            }),
            step2: this._formBuilder.group({

            }),
        });

        this.init();
    }

    public patchForm(value:DocUserField[]){
        if(!value || value.length == 0 || this.patched) {
            return;
        }

        Object.keys(GdprFieldNames).forEach(key => {
            const fieldVal = getRawVal(getValueOfFieldWithName(value, key, this.documentID));
            if(fieldVal != null) {
                this.fieldsData[key] = fieldVal;
            }
        });
        this.clinicName = value.find(field => field.name == BasicInfoFieldNames.basic_clinic_name).value;
        this.clinicAddress = value.find(field => field.name == BasicInfoFieldNames.basic_clinic_addr).value;
        this.clinicEmail = value.find(field => field.name == BasicInfoFieldNames.basic_clinic_email).value;
        this.patched = true;
        this.cdrf.markForCheck();
    }

    ngOnDestroy(): void {
        this.destroy();
    }

    protected readonly BasicInfoFieldNames = BasicInfoFieldNames;
    protected readonly GeneralFieldNames = GeneralFieldNames;

    protected readonly getValueOfFieldWithName = getValueOfFieldWithName;


    getAnswerText(answer: GDPRAnsw) {
        return answer.txt
            .replace("{tick}", "")
            .replace("...{extra}...", "")
            .replace("{extra}", "");
    }

    isL1Ticked(id: GdprFieldNames) {
        return this.fieldsData[id];
    }

    syncFieldCheck(answer:GDPRAnsw, $event: Event, entry:GdprQ): void {
        const newVal = ($event.target as HTMLInputElement).checked;
        this.fieldsData[answer.id] = !!(answer.inverted ? !newVal : newVal);

        const toSync: DocUserField[] = [];
        toSync.push(
            new DocUserField(this.documentID, answer.id, this.fieldsData[answer.id]+"")
        );

        if(answer.inverted){
            //clear all L2 related if first option selected
            entry.answsL2.forEach(answ2 => {
                //reset info
                this.fieldsData[answ2.id] = answ2.txt.includes("{extra}") ? "":false;
                toSync.push(new DocUserField(this.documentID, answ2.id, this.fieldsData[answ2.id]+""))
            })
        }

        this._docsService.syncFields(toSync, this.documentID);
    }

    getSelectionValue(answer: GDPRAnsw) {
        return !!((answer.inverted) ? !this.fieldsData[answer.id] : this.fieldsData[answer.id]);
    }

    syncExtraField(id: string, $event: FocusEvent) {
        this.fieldsData[id] = ($event.target as HTMLInputElement).value;
        const usrF: DocUserField = new DocUserField(this.documentID, id, this.fieldsData[id]+"");
        this._docsService.syncFields([usrF], this.documentID);
    }

    protected readonly gdprQuestions = gdprQuestions;
}
